// extracted by mini-css-extract-plugin
module.exports = {"donateAmount":"SendGift_donateAmount__3X6uC"};